var React = require('react');

function Hugo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m11.754 0a3.998 3.998 0 0 0 -2.049.596l-6.375 3.936a4.252 4.252 0 0 0 -2.017 3.615v8.03c0 1.473.79 2.838 2.067 3.574l6.486 3.733a3.88 3.88 0 0 0 3.835.018l7.043-3.966a3.817 3.817 0 0 0 1.943-3.323v-8.461a3.57 3.57 0 0 0 -1.774-3.084l-7.096-4.127a3.998 3.998 0 0 0 -2.063-.54zm.022 1.674c.413-.006.828.1 1.2.315l7.095 4.127c.584.34.941.96.94 1.635v8.462c0 .774-.414 1.484-1.089 1.864l-7.042 3.966a2.199 2.199 0 0 1 -2.179-.01l-6.485-3.734a2.447 2.447 0 0 1 -1.228-2.123v-8.03c0-.893.461-1.72 1.221-2.19l6.376-3.935a2.323 2.323 0 0 1 1.19-.347zm-4.7 3.844v12.852h2.69v-5.62h4.46v5.62h2.696v-12.852h-2.696v4.681h-4.46v-4.681z"}));
}

Hugo.defaultProps = {"fill":"currentColor","viewBox":"0 0 24 24"};

module.exports = Hugo;

Hugo.default = Hugo;
